import React from 'react';

import * as S from './style';

export function DigitalWrapperPreview({ giftWrapperUrl }) {
  return (
    <S.PhonePreview>
      <S.DigitalWrapper src={giftWrapperUrl} />
      <S.ExperienceBow />
    </S.PhonePreview>
  );
}
